import {APIClient} from '../utils/APIClient';
import {API_URL} from '../settings/local_settings';

// Capa API del Panel del cliente (V11, UX 2.1). Un solo GET arma la pantalla entera:
// `GET client/<id>/panel/` devuelve `{status:'OK', data:{client, monitored_conversion, kpis,
// lines, first_steps, media_plan, memory, portal, platforms, ai, is_new_client}}` (contrato
// pinneado v1.0). Los gates —portal-user, cliente de otra agencia, tier < UX_21— vuelven como
// 404 uniforme `{error_code:'NOT_FOUND'}`: el scope lo resuelve el backend, acá no se filtra nada.
//
// `tz_offset` va en minutos con el signo de JS (`Date.getTimezoneOffset()`, positivo al oeste de
// UTC): el backend lo usa para cortar el "día local" de los KPIs y de las ráfagas de alertas.
// Si no llega o es inválido, el backend asume 0 (UTC).
//
// Bloque `economy` (Economía del cliente, contrato 2026-09-25 §3.1): sin módulo viaja
// `{enabled:false}` y la card no se monta; con módulo y sin perfil, `{enabled:true, configured:false,
// lines_with_store}`; con perfil trae `profile`, `client_totals` (null por `MIXED_CURRENCY`),
// `lines[]` con sus derivados y su `goal.suggested`, `escalafy` y `actuals`. Cada motivo de «no se
// puede calcular» llega en `unavailable_reason` (dict campo → código): la card lo DICE en el tile,
// no lo esconde.
const BASE = API_URL + 'client/';

export const ClientPanelApi = {
    getPanel(clientId) {
        const tzOffset = new Date().getTimezoneOffset();
        const url = `${BASE}${encodeURIComponent(clientId)}/panel/?tz_offset=${tzOffset}`;
        return new APIClient(url).call('GET');
    },

    // Primeros pasos: el usuario puede ocultar la card sin completarla (persiste en
    // `_panel_first_steps_hidden_at` del AgencyClient). Ambos endpoints van sin body y
    // devuelven `{status:'OK'}`. Al ocultar/mostrar hay que refrescar el panel: `first_steps.visible`
    // lo calcula el backend (pendientes Y no oculto).
    hideFirstSteps(clientId) {
        const url = `${BASE}${encodeURIComponent(clientId)}/panel/first-steps/hide/`;
        return new APIClient(url).call('POST');
    },

    unhideFirstSteps(clientId) {
        const url = `${BASE}${encodeURIComponent(clientId)}/panel/first-steps/unhide/`;
        return new APIClient(url).call('POST');
    },

    /**
     * En qué mes va la preparación del histórico de cada cuenta del cliente:
     * `{status:'OK', data:{accounts:{'<ad_account_id>': {state, current_month, months_done,
     * months_total, data_from}}}}`. Una cuenta que ya terminó NO aparece en `accounts`.
     *
     * Endpoint propio y no el agregado: la preparación tarda horas, así que la barra tiene que
     * avanzar sola, y re-pedir `panel/` cada minuto son ~65 queries por pestaña abierta para
     * actualizar una línea de texto. Este cuesta 3. Los shapes por cuenta son LOS MISMOS que
     * viajan en `panel.platforms.client_ad_accounts[].historical_sync` — los arma el mismo
     * servicio del backend — así que el frontend los mezcla sin adaptador.
     */
    getPlatformsSyncProgress(clientId) {
        const url = `${BASE}${encodeURIComponent(clientId)}/platforms/sync-progress/`;
        return new APIClient(url).call('GET');
    },
};
